import { render, staticRenderFns } from "./AdminServerInfo.vue?vue&type=template&id=24fc1e6e&scoped=true&"
import script from "./AdminServerInfo.vue?vue&type=script&lang=js&"
export * from "./AdminServerInfo.vue?vue&type=script&lang=js&"
import style0 from "./AdminServerInfo.vue?vue&type=style&index=0&id=24fc1e6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fc1e6e",
  null
  
)

export default component.exports